export const DATE_FORMATS = {
  SHORT: 'D MMM YYYY',
  LONG: 'D MMM YYYY, HH:mm',
  FULL: 'dddd, D MMM YYYY, HH:mm',
  TIME_ONLY: 'HH:mm',
  DATEPICKER_DEFAULT: 'd MMM yyyy, HH:mm',
  SCHEDULE_FORM_FIELD: 'D MMM YYYY, HH:mm',
  SCHEDULE_REQUEST: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  SCHEDULE_REQUEST_TIME_ONLY: 'HH:mm:ss.SSSZ',
  DEFAULT: 'D MMM YYYY, HH:mm',
}
